import React, { useEffect } from 'react';
import { Loader2 } from 'lucide-react';
interface LoadingScreenProps {
  onComplete: () => void;
}
export function LoadingScreen({
  onComplete
}: LoadingScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="flex flex-col w-full h-full min-h-screen bg-brand-dark text-white items-center justify-center px-6 text-center" data-id="element-16">
      <Loader2 className="w-12 h-12 text-brand-accent animate-spin mb-8" data-id="element-17" />
      <h1 className="text-2xl font-bold text-white mb-3" data-id="element-18">
        Building your Founder's Idea Kit...
      </h1>
      <p className="text-brand-surface/80 text-base" data-id="element-19">
        This takes about 30 seconds.
      </p>
    </div>;
}